import { BaseControl } from './base-control';

import {
  PhoneAutocompleteValueInterface,
  PhoneAutocompleteControlInterface,
  PhoneAutocompleteCountryInterface,
} from '../components/phone-autocomplete/interfaces';

export class PhoneAutocompleteControl extends BaseControl<PhoneAutocompleteValueInterface> {
  public countries: PhoneAutocompleteCountryInterface[];

  constructor(data: PhoneAutocompleteControlInterface) {
    super(data);

    this.countries = data.countries;
  }
}
